import { render, staticRenderFns } from "./appHeader.vue?vue&type=template&id=2f63b3fd&scoped=true&"
import script from "./appHeader.vue?vue&type=script&lang=js&"
export * from "./appHeader.vue?vue&type=script&lang=js&"
import style0 from "./appHeader.vue?vue&type=style&index=0&id=2f63b3fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f63b3fd",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TextSearch: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/app/filters/textSearch.vue').default})
